import { MDBBtn, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import Image from "next/legacy/image";
import { useState } from "react";
import { ISectionTitle } from "@/models/common/common";
import { helpSubTitle, helpTitle } from "@/utils/mockData/playWithUsMock";
import { randomUid } from "@/utils/randomIds";
import styles from "../../styles/playWithUs/PlayWithUs.Help.module.scss";
import SectionTitle from "../common/SectionTitle";
import phonePic from "../../public/images/Help-Phone.png";
import messagePic from "../../public/images/Help-Message.png";
import TalkWithUs from "../common/TalkWithUs";

const Help = () => {
    const [showModal, setShowModal] = useState(false);
    const helpItems = [
        {
            image: phonePic,
            name: "Here’s our number",
        },
        {
            image: messagePic,
            name: "Here’s our contacts",
        },
    ];

    const title: ISectionTitle = {
        title: helpTitle,
        subTitle: helpSubTitle,
        titleColumnSize: 12,
        alignment: "justify-content-center text-center",
        classNameContainer: "py-3",
    };

    return (
        <MDBContainer fluid className={`${styles.container}`}>
            <TalkWithUs show={showModal} setShow={setShowModal} />
            <MDBRow className="justify-content-center">
                <MDBCol
                    center
                    size={10}
                    lg={10}
                    xl={9}
                    className={`${styles.containerCard} ${styles.marginBoxToContainer} d-flex flex-column align-items-center py-5 my-5`}
                >
                    <MDBRow className="justify-content-center">
                        <SectionTitle sectionTitle={title} />
                    </MDBRow>
                    <MDBRow className="w-100 justify-content-center justify-content-md-evenly px-md-3 px-lg-0">
                        {helpItems.map(
                            (el, index) =>
                                helpItems.length > 0 &&
                                index === 1 && (
                                    <MDBCol
                                        key={randomUid()}
                                        size={10}
                                        md={5}
                                        lg={5}
                                        className={`${styles.columnItem} mt-4 px-lg-3 px-xl-4 py-5`}
                                    >
                                        <MDBRow>
                                            <MDBCol
                                                size={4}
                                                lg={4}
                                                center
                                                className="ms-lg-4"
                                            >
                                                <Image
                                                    src={el.image}
                                                    alt={`Picture of the ${el.name}`}
                                                    sizes="320 640"
                                                    className="w-50 h-50"
                                                />
                                            </MDBCol>
                                            <MDBCol
                                                size={8}
                                                lg={7}
                                                xl={7}
                                                center
                                                className="d-inline-flex flex-column"
                                            >
                                                <MDBCol size={12} center>
                                                    {el.name}
                                                </MDBCol>
                                                <MDBCol lg={12} xl={11}>
                                                    <MDBBtn
                                                        className={`${styles.buttonHelp} mt-2 shadow-0`}
                                                        onClick={() =>
                                                            setShowModal(true)
                                                        }
                                                    >
                                                        open pop-up
                                                    </MDBBtn>
                                                </MDBCol>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCol>
                                )
                        )}
                    </MDBRow>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
};

export default Help;
